import db from "../driverappdb";

export const DropTypeRepository = {
    getDropTypes: async (dropTypeIds) => {
        return await db.droptypes.bulkGet(dropTypeIds);
    }
};